import api from '@/utils/api'

export default {
    getAssignmentStatusCount(filter) {
        const params = new URLSearchParams()
        if (filter.contractorId) {
            params.append('contractorId', filter.contractorId)
        }
        if (filter.type) {
            params.append('type', filter.type)
        }
        return api.get('assignments/counts' + `?${params.toString()}`)
    }
}
